<section id="region-gestion-tramites">
    <div class="page__content">
        <div class="content__inner">
            <ul class="row list-unstyled">
                <li *ngFor="let gestion of gestionTramites; let i = index" [class]="gestion.type == 'redirect' ? 'col-sm-2 col-lg-2 col-xl-1-5 text-center' : 'col'">
                    <!--Bloque para las acciones de redireccion-->
                    <a [href]="normalizeCardHref(gestion.url)"
                       (click)="onRedirectCardClick(gestion.url, $event)"
                       [class]="gestion.url=='#/inicio#region-tramites'?'linkActivo':''"
                       *ngIf="gestion.type == 'redirect'">
                        <div>
                            <img src="{{ gestion.imagen }}" [alt]="gestion.titleKey ? (gestion.titleKey | translate) : gestion.titulo" />
                        </div>
                        <div>
                            <h3 class="font18">{{ gestion.titleKey ? (gestion.titleKey | translate) : gestion.titulo }}</h3>
                            <p>{{ gestion.descriptionKey ? (gestion.descriptionKey | translate) : gestion.descripcion }}</p>
                        </div>
                    </a>
                    <!--Bloque para las acciones input-->
                    <div class="h-100" *ngIf="gestion.type == 'input'">
                        <div class="validar h-100">
                            <h2 class="marginTop2rem">{{ gestion.titleKey ? (gestion.titleKey | translate) : gestion.titulo }}</h2>
                            <p class="font18 marginTop1rem">{{ gestion.descriptionKey ? (gestion.descriptionKey | translate) : gestion.descripcion }}</p>
                            <form class="form-inline my-2 my-lg-0 marginTop4rem" (ngSubmit)="submitCardAction(gestion.action, i)" >
                                <div class="col-12 col-sm-12 col-lg-10 col-xl-7">
                                <input class="form-control mr-sm-2 w-100" type="search"
                                    [placeholder]="gestion.placeholderKey ? (gestion.placeholderKey | translate) : gestion.placeHolderInput" aria-label="Search" (keyup)="setValue($event,i)">
                                </div>
                                <div class="col-12 col-sm-12 col-lg-2 col-xl-5 mw-100">
                                <button class="btn btn-primary my-2 my-lg-0 w-100 " type="submit" [disabled]="gestion.loading != null && gestion.loading == true">{{ gestion.buttonKey ? (gestion.buttonKey | translate) : gestion.textButtonInput }}</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    
    <ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "ball-clip-rotate" [fullScreen] = "true" [name]="'gestion_tramites_spinner'">
        <p style="color: white" >{{mensajeSpinner}}</p>
    </ngx-spinner>        
    
</section>
